import * as React from 'react';
import type { SVGProps } from 'react';
const SvgUnlock = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    {...props}
  >
    <path
      fill='currentColor'
      d='M6 11a1 1 0 1 0 2 0zm1-4h1v-.001zm8.92-.801a1 1 0 0 0 1.96-.398zM5 12h14v-2H5zm14 0a1 1 0 0 1 1 1h2a3 3 0 0 0-3-3zm1 1v7h2v-7zm0 7a1 1 0 0 1-1 1v2a3 3 0 0 0 3-3zm-1 1H5v2h14zM5 21a1 1 0 0 1-1-1H2a3 3 0 0 0 3 3zm-1-1v-7H2v7zm0-7a1 1 0 0 1 1-1v-2a3 3 0 0 0-3 3zm4-2V7H6v4zm0-4.001a4 4 0 0 1 1.031-2.685l-1.484-1.34A6 6 0 0 0 6 7zm1.031-2.685a4 4 0 0 1 2.567-1.299l-.201-1.99a6 6 0 0 0-3.85 1.948zm2.567-1.299a4 4 0 0 1 2.774.76l1.187-1.61a6 6 0 0 0-4.162-1.14zm2.774.76a4 4 0 0 1 1.548 2.424l1.96-.398a6 6 0 0 0-2.321-3.637z'
    />
  </svg>
);
export default SvgUnlock;
